import * as React from 'react';
import { useState, useEffect, useRef } from 'react';
import Pagination from '@mui/material/Pagination';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';

const PaginationAndSearching = ({
    handleSearch,
    searchValue,
    totalCount,
    pageSize,
    handleChangeRowsPerPage,
    onChange,
}) => {
    const [currentPage, setCurrentPage] = useState(1);

    const handlePageChange = (event, page) => {
        setCurrentPage(page);
        onChange(page);
    };

    useEffect(() => {
        if (searchValue.trim().length > 2 || searchValue.trim().length === 0) {
            setCurrentPage(1);
        }
    }, [searchValue]);

    return (
        <Box display="flex" flexDirection="column" alignItems="center" mt={2}>
            <Stack spacing={2}>
                <Pagination
                    count={totalCount}
                    page={currentPage}
                    onChange={handlePageChange}
                    shape="rounded"
                    variant="outlined" color="primary" 
                />
            </Stack>
        </Box>
    );
}

export default PaginationAndSearching;
